


export const tokenAddress = "0x501fB6D8Bbc65FA6a62CE7B46a786E73C4017b17";

export const stakingAddress = "0x9f3B307a73C4a007b147d8CAa1cdf76b88b74089";

export const presaleAddress = "0x8026a3205D95e4Dd34A61c16f371317C072D322a";
